import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

// Define props used in the styles
interface StyleProps {
  isMobile?: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  root: ({ isMobile }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: isMobile ? "center" : "flex-start",
    alignItems: "center",
    padding: "8px 0px",
  }),
  label: ({ isMobile }) => ({
    color: theme.palette.gray80.main,
    fontSize: "12px",
    lineHeight: "24px",
    letterSpacing: "0.4px",
    minWidth: isMobile ? "0px" : "220px",
    width: isMobile ? "100%" : "0px",
    textAlign: isMobile ? "left" : "right",
    paddingRight: "16px",
  }),
  value: ({ isMobile }) => ({
    color: theme.palette.darkBase.main,
    fontSize: "16px",
    letterSpacing: "0.25px",
    minWidth: isMobile ? "0px" : "324px",
    width: isMobile ? "100%" : "0px",
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  dropzoneRoot: {
    minHeight: "unset !important",
    height: 152,
    borderRadius: 8,
    color: theme.palette.gray60.main,
  },
  muiSvgIcon: {
    marginTop: 24,
    color: "#919699 !important",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center",
    width: "auto",
  },
  text: {
    "&:after": {
      content: "'ide'",
      color: "red",
      transform: "translateX(-100%)",
      position: "absolute",
    },
  },
  tooLongValueTooltip: {
    fontSize: "14px",
    lineHeight: "20px",
    padding: "2px 8px",
  },
  input: {
    height: "4px",
  },
  errorText: {
    color: theme.palette.primary.main,
    margin: "0",
    fontSize: "12px",
    marginTop: "3px",
    textAlign: "left",
    fontWeight: "400",
    lineHeight: "16px",
    letterSpacing: "0.4px",
    paddingLeft: "14px",
    marginBottom: "-15px",
  },
  labelTitle: {
    letterSpacing: "0.15px",
    padding: "28px 10px 10px 16px",
    color: theme.palette.darkBase.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
}));

export default useStyles;
